<template>
  <ProductoLayoutList>
    <template v-slot:list>
      <v-container fluid>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="productos"
          :search="search"
          item-key="id"
          show-select
          v-model="selectedProduct"
          :hide-default-footer="true"
          disable-pagination
          no-data-text="No se encontraron productos"
          no-results-text="Sin coincidencia para la búsqueda"
          dense
        >
          <template v-slot:top>
            <v-toolbar flat v-if="selected.length" color="white darken-4" light>
              <v-btn icon @click="removeSelected">
                <v-icon>mdi-close</v-icon>
              </v-btn>

              <v-toolbar-title>
                {{
                  selected.length === 1
                    ? "1 seleccionado"
                    : `${selected.length} seleccionados`
                }}
              </v-toolbar-title>

              <v-divider class="mx-4" inset vertical></v-divider>

              <slot name="search"></slot>

              <slot name="acciones-before-spacer" :selected="selected"></slot>

              <v-spacer></v-spacer>

              <slot name="acciones-after-spacer" :selected="selected"></slot>
            </v-toolbar>
            <slot name="content-after-toolbar" :selected="selected"></slot>
          </template>

          <!-- Checkbox -->
          <template v-slot:headers="props">
            <tr>
              <th>
                <v-checkbox
                  dense
                  :input-value="props.all"
                  :indeterminate="props.indeterminate"
                  primary
                  hide-details
                  @click.stop="toggleAll"
                ></v-checkbox>
              </th>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : '',
                ]"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                <h2>{{ header.text }}</h2>
              </th>
            </tr>
          </template>

          <template v-slot:item.descripcion_global="{ item }">
            <slot name="acciones-descripcion-global" :item="item"> </slot>
          </template>
          <template v-slot:item.descripcion_comercial="{ item }">
            <slot name="acciones-descripcion" :item="item"> </slot>
          </template>
          <template v-slot:item.precio_costo_base="{ item }">
            <span class="">{{ item.precio_costo_base | convertPesoArg }}</span>
          </template>
          <template v-slot:item.precio_venta_sugerido="{ item }">
            <span class="">{{
              item.precio_venta_sugerido | convertPesoArg
            }}</span>
          </template>
          <template v-slot:item.iva.description="{ item }">
            <span class="">{{ item.iva.description }}%</span>
          </template>
          <template v-slot:item.margen_ganancia_sugerido="{ item }">
            <span class="">{{ item.margen_ganancia_sugerido }}%</span>
          </template>
          <template v-slot:item.sucursales_compartidas="{ item }">
            <div class="align-center justify-start flex-wrap">
              <v-chip
                v-for="(sucursal, index) in item.sucursales_compartidas.slice(
                  0,
                  2
                )"
                :key="index"
                class="ma-1"
                small
              >
                {{ sucursal.sucursal.nombre }} (
                {{ sucursal.precio_venta | convertPesoArg }} )
              </v-chip>

              <v-btn
                v-if="item.sucursales_compartidas.length > 2"
                text
                small
                color="primary"
                class="ma-1"
                @click="abrirDialogSucursales(item)"
              >
                +{{ item.sucursales_compartidas.length - 2 }} más
              </v-btn>
            </div>
          </template>

          <template v-slot:item.precioVenta="{ item }">
            <span class="title">{{ item.precioVenta | convertPesoArg }}</span>
          </template>
        </v-data-table>
        <!-- Dialog para mostrar todas las sucursales -->
        <v-dialog v-model="dialogSucursales.visible" max-width="500px">
          <v-card>
            <v-card-title class="headline"> Sucursales asignadas </v-card-title>
            <v-card-text>
              <v-list dense>
                <v-list-item
                  v-for="(sucursal, index) in dialogSucursales.sucursales"
                  :key="index"
                >
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-store</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      sucursal.sucursal.nombre
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>{{
                    sucursal.precio_venta | convertPesoArg
                  }}</v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="dialogSucursales.visible = false"
              >
                Cerrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </template>
  </ProductoLayoutList>
</template>

<script>
import { mapState } from "vuex";
import ProductoLayoutList from "./ProductoLayoutList.vue";
export default {
  name: "produtos.list.table",
  components: { ProductoLayoutList },
  props: {
    productos: {
      type: Array,
      required: true,
      default: () => [],
    },

    verBuscador: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    selected: [],
    dialogSucursales: {
      visible: false,
      sucursales: [],
    },
    menuOpen: false, // 👈 esto es clave

    search: "",
    openSearch: false,
    loading: false,

    filtros: null,
    selectedItem: false,
  }),
  computed: {
    ...mapState("sucursales", ["configuracion"]),
    selectedProduct: {
      get() {
        return this.selected;
      },
      set(val) {
        this.selected = val;
        this.$emit("process-productos-selected", val);
        return;
      },
    },

    pages() {
      if (this.paginacion.rowsPerPage == null || this.paginacion.cantidad < 0) {
        return 0;
      }

      return Math.ceil(this.paginacion.cantidad / this.paginacion.rowsPerPage);
    },
    headers() {
      if (this.configuracion.productoInventario) {
        return [
          {
            text: "Catálogo",
            value: "descripcion_global",
            align: "start",
            width: "300px",
          },
          {
            text: "Producto",
            value: "descripcion_comercial",
            align: "start",
            width: "300px",
          },

          // {
          //   text: "Marca",
          //   value: "marca.nombre",
          //   align: "center",
          // },

          {
            text: "Precio de venta sugerido",
            value: "precio_venta_sugerido",
            align: "center",
          },
          // {
          //   text: "Ganancia",
          //   value: "margen_ganancia_sugerido",
          //   align: "center",
          // },

          // {
          //   text: "IVA",
          //   value: "iva.description",
          //   align: "center",
          // },
          {
            text: "Sucursales asignadas",
            value: "sucursales_compartidas",
            align: "center",
          },
        ];
      } else {
        return [
          {
            text: "Producto",
            value: "descripcion",
            align: "center",
          },
          {
            text: "Marca",
            value: "marca.nombre",
            align: "center",
          },
          {
            text: "Proveedor",
            value: "proveedor.nombre",
            align: "center",
          },
          {
            text: "P. Costo",
            value: "precioCosto",
            align: "center",
          },
          {
            text: "P. Venta",
            value: "precioVenta",
            align: "center",
          },
          {
            text: "Ganancia",
            value: "ganancia",
            align: "center",
          },

          {
            text: "IVA",
            value: "iva",
            align: "center",
          },
        ];
      }
    },
  },

  methods: {
    removeSelected() {
      this.selected = [];
      this.$emit("remove-selected");
    },
    abrirDialogSucursales(item) {
      this.dialogSucursales.sucursales = item.sucursales_compartidas;
      this.dialogSucursales.visible = true;
    },
    mostrarInfo(producto) {
      // Aquí obtienes el uuid_empresa de la ruta actual
      const uuid_empresa = this.$route.params.uuid_empresa;

      // Rediriges al usuario a la ruta 'productoEmpresaDetalle' pasando los parámetros necesarios
      this.$router.push({
        name: "productoEmpresaDetalle",
        params: {
          uuid_empresa: uuid_empresa,
          id_producto: producto.id,
        },
      });
    },
    selectItem(item) {
      if (!this.menuOpen) {
        this.selectedItem = item;
      }
    },
    unSelectItem() {
      if (!this.menuOpen) {
        this.selectedItem = false;
      }
    },
    cleanSelected() {
      this.selected = [];
    },
    getColor(producto) {
      var cantidadstock = parseInt(producto.cantidadstock);

      var stockmin = parseInt(producto.stockmin);

      var stockmax = parseInt(producto.stockmax);

      var stockPromedio = (stockmin + stockmax) / 2;

      var stockLimiteAprobado = stockmin + stockmin * 0.2;
      console.log("cantidadstock", cantidadstock);
      console.log("stockLimiteAprobado", stockLimiteAprobado);

      if (cantidadstock > stockLimiteAprobado) return "green";
      else if (stockLimiteAprobado < cantidadstock && cantidadstock > stockmin)
        return "orange";
      else return "red";
    },

    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.productos.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    verificarCantidadSeleccionada() {
      let selected = this.selected;
      if (this.selected.length == 0) {
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "warning",
          text: "Debe seleccionar un producto",
          icon: "new_releases",
          timeout: 3000,
        });
      } else {
        return true;
      }
    },

    reset() {
      this.$refs.form.reset();
    },
  },
  watch: {
    productos: {
      immediate: true,
      deep: true,
      handler(newArray, oldArray) {
        if (newArray.length == !oldArray.length) this.selected = [];
      },
    },
  },
};
</script>

<style >
.v-datatable thead {
  background-color: rgb(190, 65, 65);
}

.table-scroll-wrapper {
  overflow: auto;
  border: var(--border-size-s) solid var(--color-neutral-4);
}

.table-scroll {
  margin: 0px;
  border: none;
}

.table-scroll thead th {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}

.table-scroll tr td:first-child,
.table-scroll th:first-child {
  position: -webkit-sticky;
  position: sticky;
  width: 120px;
  left: 0;
  z-index: 2;
  border-right: var(--border-size-s) solid var(--color-neutral-4);
}

.table-scroll th:first-child {
  z-index: 3;
}

.table-scroll tr td:nth-child(2),
.table-scroll th:nth-child(2) {
  position: -webkit-sticky;
  position: sticky;
  width: 120px;
  left: 64px;
  z-index: 2;
  border-right: var(--border-size-s) solid var(--color-neutral-4);
  background: #1e1e1e;
}

.table-scroll th:nth-child(2) {
  z-index: 4;
}

.table-scroll tr td:nth-child(3),
.table-scroll th:nth-child(3) {
  position: -webkit-sticky;
  position: sticky;
  width: 200px;

  left: 134px;
  z-index: 2;
  border-right: var(--border-size-s) solid var(--color-neutral-4);
  background: #1e1e1e;
}

.table-scroll th:nth-child(3) {
  z-index: 4;
}
</style>
